import {inject, Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {LoadingService} from "../services/commons/loading.service";

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  public loadingService = inject(LoadingService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap((ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
            if (request.headers.has('x-current-loading')) {
              this.loadingService.currentLoading.update(()=>this.loadingService.currentLoading().filter(x => x !== request.headers.get('x-current-loading')));
            }
          }
        })
      );
  }
}
